import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReporterService from "./ReporterService";
import AdvertiserService from "./AdvertiserServices";
import InfluencersService from "./InfluencersServices";
import DrLawyer from "./DrLawyer";
import MarketerService from "./MarketerService";
import Newspaper from "./Newspaper";
import Website from "../ServiceSection/Website";

const Services = ({ activeCareer, setActiveCareer }) => {
  const navigate = useNavigate();
  const [activeService, setActiveService] = useState(activeCareer);
  const [touchedService, setTouchedService] = useState(null); // Add this state

  useEffect(() => {
    setActiveService(activeCareer);
  }, [activeCareer]);

  const handleServiceClick = (service) => {
    setActiveService(service.title);
    if (setActiveCareer) {
      setActiveCareer(service.title);
    }
    if (service.link && service.link !== "#") {
      navigate(service.link);
    }
  };

  const handleTouchStart = (serviceTitle) => {
    setTouchedService(serviceTitle);
  };

  const handleTouchEnd = () => {
    setTouchedService(null);
  };

  const servicesData = [
    {
      title: "Reporter",
      description: "",
      bgColor: "bg-blue-100",
      iconBgColor: "bg-blue-600",
      iconColor: "text-blue-600",
      image: "/assets/reporter.png",
      link: "/login",
    },
    {
      title: "IINSAF Ads",
      description: "",
      bgColor: "bg-orange-100",
      iconBgColor: "bg-orange-500",
      iconColor: "text-orange-600",
      image: "/assets/ads-career.png",
      link: "/login",
    },
    {
      title: "Marketer",
      description: "",
      bgColor: "bg-red-100",
      iconBgColor: "bg-red-500",
      iconColor: "text-red-600",
      image: "/assets/marketer.png",
      link: "/login",
    },
    {
      title: "Influencer",
      description: "",
      bgColor: "bg-blue-100",
      iconBgColor: "bg-blue-600",
      iconColor: "text-blue-600",
      image: "/assets/influencer-career.png",
      link: "/login",
    },
    {
      title: "Join Organization ",
      description: "",
      bgColor: "bg-red-100",
      iconBgColor: "bg-red-500",
      iconColor: "text-red-600",
      image: "/assets/lawyer.png",
      link: "/join-organization",
    },
    {
      title: "Newspaper",
      description: "",
      bgColor: "bg-red-100",
      iconBgColor: "bg-red-500",
      iconColor: "text-red-600",
      image: "/assets/marketer.png",
      link: "/login",
    },
    {
      title: "Website",
      description: "",
      bgColor: "bg-blue-100",
      iconBgColor: "bg-blue-500",
      iconColor: "text-blue-600",
      image: "/assets/marketer.png",
      link: "/login",
    },
  ];

  const getServiceComponent = () => {
    switch (activeService) {
      case "Reporter":
        return <ReporterService />;
      case "Advertiser":
        return <AdvertiserService />;
      case "Marketer":
        return <MarketerService />;
      case "Influencer":
        return <InfluencersService />;
      case "Dr, Lawyer":
        return <DrLawyer />;
      case "Newspaper":
        return <Newspaper />;
      case "Website":
        return <Website />;
      default:
        return null;
    }
  };

  const getActiveServiceIcon = () => {
    const service = servicesData.find((s) => s.title === activeService);
    return service ? service.image : null;
  };

  return (
    <>
      <div
        id="career"
        className="flex flex-col lg:flex-row items-center justify-center lg:justify-end gap-4 md:gap-8 px-4 md:px-6 lg:px-16 py-6 md:py-10 bg-gray-100 relative min-h-screen overflow-hidden"
      >
        {/* Logo Section - Enhanced with smooth styling and entrance animation */}
        <div className="flex-shrink-0 relative mb-6 md:mb-8 lg:mb-0 w-full lg:w-1/2 flex justify-center lg:justify-end animate-fade-in-left">
          <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 lg:w-52 lg:h-48 relative border-r-4 border-dotted border-black rounded-full flex justify-center items-center transition-all duration-700 ease-out hover:scale-105 hover:rotate-3 group shadow-2xl hover:shadow-3xl backdrop-blur-sm">
            {/* Outer ring with smooth animation */}
            <div className="absolute inset-0 rounded-full border-2 border-dashed border-gray-300/50 transition-all duration-700 ease-out group-hover:border-blue-400/70 group-hover:scale-105 group-hover:rotate-12"></div>

            {/* Main logo container */}
            <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32 lg:w-36 lg:h-36 rounded-full flex items-center justify-center relative overflow-hidden transition-all duration-700 ease-out group-hover:scale-115 group-hover:rotate-12 bg-gradient-to-br from-white/90 to-white/70 backdrop-blur-md shadow-xl">
              {/* Background gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-purple-50/20 to-transparent rounded-full"></div>

              {/* Main logo image */}
              <img
                src="/assets/icon.jpg"
                alt="IINSAF Logo"
                className="absolute inset-0 w-full h-full object-cover z-10 opacity-95 filter brightness-110 contrast-110 transition-all duration-700 ease-out group-hover:brightness-125 group-hover:contrast-120 group-hover:scale-110 drop-shadow-lg"
              />

              {/* Active service overlay */}
              <img
                className="absolute inset-0 w-full h-full object-cover opacity-70 transition-all duration-700 ease-out group-hover:opacity-85 group-hover:scale-110 drop-shadow-md"
                src={getActiveServiceIcon()}
                alt={activeService}
              />

              {/* Shimmer effect overlay */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-700 ease-out rounded-full animate-pulse"></div>

              {/* Inner glow effect */}
              <div className="absolute inset-2 rounded-full bg-gradient-to-br from-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-out"></div>
            </div>

            {/* Floating particles effect */}
            <div className="absolute -top-2 -right-2 w-3 h-3 bg-blue-400/60 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-700 ease-out group-hover:animate-bounce"></div>
            <div className="absolute -bottom-2 -left-2 w-2 h-2 bg-purple-400/60 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-700 ease-out group-hover:animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            <div className="absolute top-1/2 -right-4 w-1.5 h-1.5 bg-green-400/60 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-700 ease-out group-hover:animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>

        {/* Services List - Responsive adjustments with entrance animation */}
        <div className="flex flex-col gap-3 md:gap-4 lg:gap-6 w-full lg:w-1/2 relative lg:ml-8 animate-fade-in-right">
          {servicesData.map((service, index) => (
            <div
              key={index}
              className={`
                flex items-center gap-2 md:gap-3
                ${service.bgColor}
                p-3 md:p-4 w-full
                rounded-2xl shadow-lg
                relative
                transition-all
                duration-500 ease-out
                hover:shadow-xl hover:scale-[1.01] hover:brightness-105
                ${touchedService === service.title
                  ? "scale-[1.01] shadow-2xl brightness-110 transform-gpu"
                  : ""
                }
                ${
                // Adjusted margins for mobile and desktop
                index === 0
                  ? "ml-0 lg:-ml-32"
                  : index === 1
                    ? "ml-0 lg:-ml-12"
                    : index === 2
                      ? "ml-0 lg:ml-4"
                      : index === 3
                        ? "ml-0 lg:ml-14"
                        : index === 4
                          ? "ml-0 lg:ml-4"
                          : index === 5
                            ? "ml-0 lg:-ml-12"
                            : index === 6
                              ? "ml-0 lg:-ml-32"
                              : "ml-0"
                }
                rounded-r-full
                cursor-pointer
                backdrop-blur-sm
                ${activeService === service.title ||
                  touchedService === service.title
                  ? "border-2 border-blue-500 ring-4 ring-blue-200/50"
                  : "border-2 border-transparent hover:border-blue-300/50"
                }
                group
                before:content-['']
                before:absolute
                before:inset-0
                before:rounded-2xl
                before:bg-gradient-to-r
                before:from-white/20
                before:to-transparent
                before:opacity-0
                hover:before:opacity-100
                before:transition-opacity
                before:duration-300
              `}
              onClick={() => handleServiceClick(service)}
              onTouchStart={() => handleTouchStart(service.title)}
              onTouchEnd={handleTouchEnd}
              onTouchCancel={handleTouchEnd}
            >
              {/* Icon Container - Responsive adjustments */}
              <div
                className={`
                  ${service.iconBgColor}
                  text-white
                  p-2 md:p-3
                  rounded-full
                  absolute
                  w-[50px] h-[50px] md:w-[65px] md:h-[65px]
                  flex items-center justify-center
                  left-[-18px] md:left-[-25px]
                  ${service.iconColor}
                  transition-all
                  duration-500 ease-out
                  hover:scale-105 hover:rotate-3
                  ${touchedService === service.title
                    ? "rotate-6 scale-105 transform-gpu"
                    : ""
                  }
                  border-[3px] md:border-[4px]
                  border-white
                  shadow-xl
                  ${touchedService === service.title ? "shadow-2xl" : ""}
                  ring-4
                  ring-offset-2
                  ring-${service.iconBgColor.split("-")[1]}-300/60
                  ${touchedService === service.title
                    ? `ring-${service.iconBgColor.split("-")[1]}-400/80`
                    : ""
                  }
                  backdrop-blur-sm
                  before:content-['']
                  before:absolute
                  before:inset-0
                  before:rounded-full
                  before:border-2
                  before:border-dashed
                  before:border-white/60
                  before:transition-all
                  before:duration-300
                  ${touchedService === service.title
                    ? "before:border-white/90 before:scale-105"
                    : ""
                  }
                  after:content-['']
                  after:absolute
                  after:inset-0
                  after:rounded-full
                  after:bg-gradient-to-br
                  after:from-white/20
                  after:to-transparent
                  after:opacity-0
                  hover:after:opacity-100
                  after:transition-opacity
                  after:duration-300
                `}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className={`
                    w-7 h-7 md:w-9 md:h-9 
                    rounded-full 
                    transition-all
                    duration-500 ease-out
                    hover:scale-105 hover:rotate-2
                    ${touchedService === service.title ? "scale-105 rotate-3 transform-gpu" : ""}
                    filter drop-shadow-lg
                    ${touchedService === service.title ? "drop-shadow-xl brightness-110" : ""}
                  `}
                />
              </div>
              {/* Title Container - Responsive adjustments */}
              <div
                className={`
                pl-[45px] md:pl-[55px] 
                w-full 
                transition-all 
                duration-500 ease-out
                ${touchedService === service.title
                    ? "pl-[50px] md:pl-[60px] transform-gpu"
                    : ""
                  }
              `}
              >
                <h3
                  className={`
                  ${service.iconColor}
                  font-bold text-lg md:text-xl
                  text-center
                  transition-all
                  duration-500 ease-out
                  hover:scale-105 hover:tracking-wide
                  ${touchedService === service.title ? "scale-110 tracking-wide transform-gpu" : ""}
                  ${touchedService === service.title
                      ? `${service.iconColor.replace("text", "text")}/90`
                      : ""
                    }
                  drop-shadow-sm
                  ${touchedService === service.title ? "drop-shadow-md" : ""}
                  before:content-['']
                  before:absolute
                  before:inset-0
                  before:bg-gradient-to-r
                  before:from-transparent
                  before:via-white/10
                  before:to-transparent
                  before:opacity-0
                  hover:before:opacity-100
                  before:transition-opacity
                  before:duration-300
                  relative
                `}
                >
                  {service.title}
                </h3>
              </div>
            </div>
          ))}
        </div>

        {/* Service Component Container */}
        <div className="w-full lg:w-1/3 mt-6 lg:mt-0 lg:ml-12 animate-fade-in-up">
          {getServiceComponent()}
        </div>
      </div>
    </>
  );
};

export default Services;
